import React from 'react';

const ProcessSection = () => {
  return (
      <section className="w-full mb-0">
        <div className="w-full">
          <video 
            className="w-full block h-[649px] sm:h-[800px] md:h-[650px]" 
            style={{ objectFit: 'cover' }}
            autoPlay
            muted
            loop
            playsInline
          >
            <source src="/videos/fff.mp4" type="video/mp4" />
          </video>
        </div>
      </section>
  );
};export default ProcessSection;